export default __webpack_public_path__ + "static/media/icon-verify-phone.ead823fd.svg";